'use client';

import { useInstantSearch } from 'react-instantsearch';

/**
 * Search results wrapper that only renders when there's a search query (v7 version)
 */
const SearchResultsWrapperNext = t0 => {
  const {
    children
  } = t0;
  const {
    results
  } = useInstantSearch();
  if (!results || !results.query) {
    return null;
  }
  return children;
};
export default SearchResultsWrapperNext;